import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumFeatureFlag implements BaseEnumType {
  private static allValues: EnumFeatureFlag[] = []; // make sure this is top-most
  
  public static showSupportFunctions = new EnumFeatureFlag(0, "ShowSupportFunctions", "enum_feature_flag_show_support_functions");
  public static showGallery = new EnumFeatureFlag(1, "ShowGallery", "enum_feature_flag_show_gallery");
  public static showQuickbooksSandbox = new EnumFeatureFlag(2, "ShowQuickbooksSandbox", "enum_feature_flag_show_quickbooks_sandbox");
  public static v6ContainerMigrator = new EnumFeatureFlag(4, "V6ContainerMigrator", "enum_feature_flag_v6_container_migrator");
  public static vesselSummaryUpdates = new EnumFeatureFlag(5, "VesselSummaryUpdates", "enum_feature_flag_vessel_summary_updates");
  public static onlyDev = new EnumFeatureFlag(6, "OnlyDev", "enum_feature_flag_only_dev");
  public static showLabelOrder = new EnumFeatureFlag(7, "ShowLabelOrder", "enum_feature_flag_show_label_order");
  public static hideBillingPastDueDateWarning = new EnumFeatureFlag(8, "HideBillingPastDueDateWarning", "enum_feature_flag_hide_billing_past_due_date_warning");
  public static showIllinoisTaxReturn = new EnumFeatureFlag(9, "ShowIllinoisTaxReturn", "enum_feature_flag_show_illinois_tax_return");
  public static showTradePortal = new EnumFeatureFlag(10, "ShowTradePortal", "enum_feature_flag_show_trade_portal");
  public static showAmazon = new EnumFeatureFlag(11, "ShowAmazon", "enum_feature_flag_show_amazon");
  public static showProductBatchTracking = new EnumFeatureFlag(12, "ShowProductBatchTracking", "enum_feature_flag_show_product_batch_tracking");
  public static obsolete_ShowBeerflex = new EnumFeatureFlag(13, "Obsolete_ShowBeerflex", "enum_feature_flag_obsolete__show_beerflex");
  public static obsolete_ShowBottleDeposit = new EnumFeatureFlag(14, "Obsolete_ShowBottleDeposit", "enum_feature_flag_obsolete__show_bottle_deposit");
  public static obsolete_ShowAgGrid = new EnumFeatureFlag(15, "Obsolete_ShowAgGrid", "enum_feature_flag_obsolete__show_ag_grid");
  public static obsolete_ShowAutoAssembled = new EnumFeatureFlag(16, "Obsolete_ShowAutoAssembled", "enum_feature_flag_obsolete__show_auto_assembled");
  public static obsolete_ShowBogof = new EnumFeatureFlag(17, "Obsolete_ShowBogof", "enum_feature_flag_obsolete__show_bogof");
  public static obsolete_ShowPlaato = new EnumFeatureFlag(18, "Obsolete_ShowPlaato", "enum_feature_flag_obsolete__show_plaato");
  public static obsolete_ShowSquare = new EnumFeatureFlag(19, "Obsolete_ShowSquare", "enum_feature_flag_obsolete__show_square");
  public static obsolete_ShowGreentree = new EnumFeatureFlag(20, "Obsolete_ShowGreentree", "enum_feature_flag_obsolete__show_greentree");
  public static obsolete_ShowProofOfDelivery = new EnumFeatureFlag(21, "Obsolete_ShowProofOfDelivery", "enum_feature_flag_obsolete__show_proof_of_delivery");
  public static obsolete_ShowSage200Web = new EnumFeatureFlag(22, "Obsolete_ShowSage200Web", "enum_feature_flag_obsolete__show_sage200_web");
  public static obsolete_ShowPallets = new EnumFeatureFlag(23, "Obsolete_ShowPallets", "enum_feature_flag_obsolete__show_pallets");
  public static obsolete_ShowDispatchNotifications = new EnumFeatureFlag(24, "Obsolete_ShowDispatchNotifications", "enum_feature_flag_obsolete__show_dispatch_notifications");
  public static obsolete_ShowLexoffice = new EnumFeatureFlag(25, "Obsolete_ShowLexoffice", "enum_feature_flag_obsolete__show_lexoffice");
  public static obsolete_ShowSmartAddress = new EnumFeatureFlag(26, "Obsolete_ShowSmartAddress", "enum_feature_flag_obsolete__show_smart_address");
  public static germanLanguageSupport = new EnumFeatureFlag(27, "GermanLanguageSupport", "enum_feature_flag_german_language_support");
  public static obsolete_MultiJourneyPlanning = new EnumFeatureFlag(28, "Obsolete_MultiJourneyPlanning", "enum_feature_flag_obsolete__multi_journey_planning");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumFeatureFlag.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isShowSupportFunctions() { return this === EnumFeatureFlag.showSupportFunctions; }
  public isShowGallery() { return this === EnumFeatureFlag.showGallery; }
  public isShowQuickbooksSandbox() { return this === EnumFeatureFlag.showQuickbooksSandbox; }
  public isV6ContainerMigrator() { return this === EnumFeatureFlag.v6ContainerMigrator; }
  public isVesselSummaryUpdates() { return this === EnumFeatureFlag.vesselSummaryUpdates; }
  public isOnlyDev() { return this === EnumFeatureFlag.onlyDev; }
  public isShowLabelOrder() { return this === EnumFeatureFlag.showLabelOrder; }
  public isHideBillingPastDueDateWarning() { return this === EnumFeatureFlag.hideBillingPastDueDateWarning; }
  public isShowIllinoisTaxReturn() { return this === EnumFeatureFlag.showIllinoisTaxReturn; }
  public isShowTradePortal() { return this === EnumFeatureFlag.showTradePortal; }
  public isShowAmazon() { return this === EnumFeatureFlag.showAmazon; }
  public isShowProductBatchTracking() { return this === EnumFeatureFlag.showProductBatchTracking; }
  public isObsolete_ShowBeerflex() { return this === EnumFeatureFlag.obsolete_ShowBeerflex; }
  public isObsolete_ShowBottleDeposit() { return this === EnumFeatureFlag.obsolete_ShowBottleDeposit; }
  public isObsolete_ShowAgGrid() { return this === EnumFeatureFlag.obsolete_ShowAgGrid; }
  public isObsolete_ShowAutoAssembled() { return this === EnumFeatureFlag.obsolete_ShowAutoAssembled; }
  public isObsolete_ShowBogof() { return this === EnumFeatureFlag.obsolete_ShowBogof; }
  public isObsolete_ShowPlaato() { return this === EnumFeatureFlag.obsolete_ShowPlaato; }
  public isObsolete_ShowSquare() { return this === EnumFeatureFlag.obsolete_ShowSquare; }
  public isObsolete_ShowGreentree() { return this === EnumFeatureFlag.obsolete_ShowGreentree; }
  public isObsolete_ShowProofOfDelivery() { return this === EnumFeatureFlag.obsolete_ShowProofOfDelivery; }
  public isObsolete_ShowSage200Web() { return this === EnumFeatureFlag.obsolete_ShowSage200Web; }
  public isObsolete_ShowPallets() { return this === EnumFeatureFlag.obsolete_ShowPallets; }
  public isObsolete_ShowDispatchNotifications() { return this === EnumFeatureFlag.obsolete_ShowDispatchNotifications; }
  public isObsolete_ShowLexoffice() { return this === EnumFeatureFlag.obsolete_ShowLexoffice; }
  public isObsolete_ShowSmartAddress() { return this === EnumFeatureFlag.obsolete_ShowSmartAddress; }
  public isGermanLanguageSupport() { return this === EnumFeatureFlag.germanLanguageSupport; }
  public isObsolete_MultiJourneyPlanning() { return this === EnumFeatureFlag.obsolete_MultiJourneyPlanning; }

  public static getValues(): readonly EnumFeatureFlag[] {
    return EnumFeatureFlag.allValues;
  }

  public static getValuesExcept0(): readonly EnumFeatureFlag[] {
    return EnumFeatureFlag.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumFeatureFlag {
    const found = EnumFeatureFlag.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumFeatureFlag - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumFeatureFlag): EnumFeatureFlag {
    const found = name ? EnumFeatureFlag.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumFeatureFlag - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumFeatureFlag>): boolean {
    return this.key === other?.key;
  }
}